import React from 'react';
import { ReactComponent as Icon } from '../../../assets/icon-real-estate.svg';
import createSvgIcon from '../../../shared/utils/create-svg-icon';

export const RealEstateIcon = createSvgIcon(<Icon />, 'RealEstateIcon');
